import styled from 'styled-components';

//Texto de la lista
const Texto = styled.p`
    float: right;
    margin: 0px 10px 0px 0px;
    color: black;

`

 
export default Texto;

